import {Component} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs/Rx';
import {ConfigService} from 'app/core/services/config.service';
import {CategoryService} from './category.service';
import {RxComponent} from 'app/core/components/common/rx.component';

@Component({
    selector: 'itpx-categories',
    templateUrl: './categories.component.html',
    styleUrls: ['./categories.component.css']
})
export class CategoriesComponent extends RxComponent {

    private url: string;
    private filterStatusFields: any = {};
    private queryParams = new URLSearchParams();
    private query: any = {};
    private baseUrl: string;
    private gridRefresh = new Subject<any>();
    private draftGridRefresh = new Subject<any>();
    private trigger = new Subject<string>();
    private catalogSubject = new BehaviorSubject<string>(null);
    private readonly topicTag: string = 'topic';
    private readonly catalogTag: string = 'catalog';
    private readonly customTopicTag: string = 'customTopic';
    private topicList: { title: string; key: string; options: any[]; config: { dropdownType: boolean; } };
    private customTopicList: { title: string; key: string; options: any[]; config: { dropdownType: boolean; } };
    private catalogList: { title: string; key: string; options: any[]; config: { dropdownType: boolean; } };
    private detailsRoute: string = '/agora/product-data/categories/{{key}}/details';
    private fields: Array<any> = [
        {
            title: 'Name',
            name: 'name',
            config: {
                type: 'link',
                route: this.detailsRoute,
                key: 'id'
            },
            sortable: false
        }, {
            title: 'Code',
            name: 'code',
            config: {
                type: 'link',
                route: this.detailsRoute,
                key: 'id'
            },
            sortable: false,
            hidden: true
        }, {
            title: 'Description',
            name: 'description',
            sortable: false,
            hidden: true
        }, {
            title: 'Catalog',
            name: 'catalog.name',
            sortable: false,
            hidden: true
        },
        {
            title: 'Leapest Topics',
            name: (data: any) => {
                return data.topics.map(_ => _.title).join(', ')
            }
        },
        {
            title: 'Custom Topics',
            name: (data: any) => {
                if (!data.customTopics) {
                    data['customTopics'] = [];
                }
                return data.customTopics.map(_ => _.title).join(', ')
            },
            hidden: true
        },
        {
            title: 'Catalog Type',
            name: 'catalog.domainSpecific',
            hidden: false,
            formatter: (val) => val ? 'Domain Specific' : 'Marketplace'
        },
        {
            title: 'Online',
            name: 'online',
            sortable: false,
            config: {
                type: 'map-inner-html',
                map: {
                    true: '<span><i class="fa fa-circle green-online" aria-hidden="true"></i></span>',
                    false: '<span><i class="fa fa-circle red-offline" aria-hidden="true"></i></span>'
                },
                icon: {
                    true: 'fa-circle green-online',
                    false: 'fa-circle red-offline'
                }
            },
            weight: 0.5
        }

    ];

    constructor(private configService: ConfigService,
                private service: CategoryService) {
        super();
        //this.url = this.configService.get('server').url + this.configService.get('endpoints').agora.categories.list.api;
        this.url = this.configService.get('server').url + this.configService.get('endpoints').agora.categories.filteredList.api + '?';
        this.baseUrl = this.configService.get('server').url + this.configService.get('endpoints').agora.categories.filteredList.api + '?';
    }

    ngOnInit() {
        this.getFilters();
        this.getTopicList();
        this.getCustomTopicList();
        this.getCatalogList();
        this.trigger.next(this.topicTag);
        this.trigger.next(this.customTopicTag);
        this.trigger.next(this.catalogTag);
    }

    getTopicList() {
        this.trigger.filter(val => val === this.topicTag)
            .zip(this.catalogSubject)
            .switchMap(([_, catalogCode]) => this.service.topicsInCatalogs(catalogCode))
            .bindToLifecycle(this).neverError().subscribe(list => {
            this.topicList = {
                title: 'Leapest Topic',
                key: this.topicTag,
                options: list,
                config: {
                    dropdownType: true
                }
            }
        });
    }

    getCustomTopicList() {
        this.trigger.filter(val => val === this.customTopicTag)
            .zip(this.catalogSubject)
            .switchMap(([_, catalogCode]) => this.service.customTopicDictionary(catalogCode))
            .bindToLifecycle(this).neverError().subscribe(list => {
            this.customTopicList = {
                title: 'Custom Topic',
                key: this.customTopicTag,
                options: list,
                config: {
                    dropdownType: true
                }
            }
        });
    }

    getCatalogList() {
        this.trigger.filter(val => val === this.catalogTag)
            .switchMap(_ => this.service.catalogDictionary()).bindToLifecycle(this).neverError().subscribe(list => {
            this.catalogList = {
                title: 'Catalog',
                key: this.catalogTag,
                options: list,
                config: {
                    dropdownType: true
                }
            }
        });
    }

    private getFilters() {
        this.filterStatusFields = {
            title: 'Status',
            key: 'status',
            options: [
                {
                    value: 'Online',
                    key: 'online',
                    checked: true
                },
                {
                    value: 'Offline',
                    key: 'offline',
                    checked: true
                },
            ]
        };
    }

    private onFilterChanges(event: any) {
        let id = event.id || null;
        let items = event.status || null;
        if (this.topicTag === id) {
            this.query[this.topicTag] = event.status[this.topicTag];
            if (id && !event.status[this.topicTag]) {
                this.trigger.next(this.topicTag);
            }
        } else if (this.customTopicTag === id) {
            this.query[this.customTopicTag] = event.status[this.customTopicTag];
            if (id && !event.status[this.customTopicTag]) {
                this.trigger.next(this.customTopicTag);
            }
        } else if (this.catalogTag === id) {
            this.query[this.catalogTag] = event.status[this.catalogTag];
            this.catalogSubject.next(event.status[this.catalogTag]);
            this.trigger.next(this.topicTag);
            this.query[this.topicTag] = null;
            this.trigger.next(this.customTopicTag);
            this.query[this.customTopicTag] = null;
            if (id && !event.status[this.catalogTag]) {
                this.trigger.next(this.catalogTag);
            }
        }
        // else if (!items['groupId'] && !items['categoryId']) {
        //     this.query['groupId'] = null;
        // }
        else if ('status' === id) {
            if (id && items) {
                let keys = Object.keys(items);
                this.query[id] = /*(id === 'categoryId') || (id === 'groupId') ? keys.map(key => items[key]) : */keys.filter(key => items[key]);
            }
        }
        this.fetchFilteredList();
    }

    private fetchFilteredList() {
        Object.keys(this.query).map(key => {
            if (key === 'status') {
                let statusList = this.query[key];
                if (statusList.includes('online') && statusList.includes('offline') || (statusList.length === 0)) {
                    return this.queryParams.delete('online');
                } else if (statusList.includes('online') && !statusList.includes('offline')) {
                    return this.queryParams.set('online', 'true');
                } else {
                    return this.queryParams.set('online', 'false');
                }
            } else {
                this.queryParams.delete(key);
                return this.query[key] ? this.queryParams.append(key, this.query[key]) : null;
            }
        });
        this.url = this.baseUrl + this.queryParams.toString();
        setTimeout(_ => this.gridRefresh.next(true), 1);
    }

    private clearUrlParams() {
        this.queryParams.delete('online');
        this.query = {};
        this.url = this.baseUrl;
        return this.queryParams;
    }

    private clearSortingClicked(e) {
        this.getFilters();
        this.clearUrlParams();
        setTimeout(_ => {
            this.gridRefresh.next(true)
        }, 3);
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/categories/categories.component.ts